$(document).on("click",".moreless-button",function(){"+ Read more"==$(this).text()?($(this).text("+ Read less"),$(".product-single__description").removeClass("description_height")):($(this).text("+ Read more"),$(".product-single__description").addClass("description_height"))}),$(document).on("click",".filter_toggle",function(){$(".filters_custom").toggle("slow")});

/* Slick sldier for Collection list */
  $(document).ready(function(){
  $('.collection-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: true,
     centerMode: true,
      centerPadding: '0px',
autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint:768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false
      }
    }
   
  ]
});

    /* Gallery Slider */
      $('.gallery-slides').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay: true,
     centerMode: true,
      centerPadding: '0px',
autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
         centerMode: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false
      }
    }
   
  ]
});
    /* Popup Modal */
	$(".gallery-data-items").on("click",function(e) {
      e.preventDefault();
	  var image_path =$(this).find("img").attr("src");
       var find_heading =$(this).find(".slide-headings").text();
      $("body").addClass("open-popup");
       if(image_path)
      {
      $(".gallery-popup").addClass("active");
      var target_div =$(".gallery-popup").find(".image-popup-inner").find("img");
      target_div.attr("src", image_path);
      }
      if(find_heading)
      {
         var target_heading =$(".gallery-popup").find(".image-popup-heading");
        target_heading.text(find_heading); 
        
      }
      if (!$(event.target).hasClass("close-gallery")) {
      e.stopPropagation();
    }
  
	});

    /* Body click function */
     $("body").on("click", function () {
     $(".gallery-popup").removeClass("active");
       var target_div =$(".gallery-popup").find(".image-popup-inner").find("img");
       var find_heading =$(".gallery-popup").find(".image-popup-inner").find(".slide-headings");
       console.log(find_heading)
      target_div.attr("src", "");
        $("body").removeClass("open-popup");
        var target_heading =$(".gallery-popup").find(".image-popup-heading");
        target_heading.text(""); 
    
  });

    /* on click popup */
        $(".gallery-popup").on("click",function(e) {
    
     if (!$(event.target).hasClass("close-gallery")) {
      e.stopPropagation();
    }
  
  });
    /* close popup */
    $(".close-gallery, .bg-overlay").on("click",function(e) {
      e.preventDefault();
	   $(".gallery-popup").removeClass("active");
      $("body").removeClass("open-popup");
      var target_div =$(".gallery-popup").find(".image-popup-inner").find("img");
      target_div.attr("src", "");
         var target_heading =$(".gallery-popup").find(".image-popup-heading");
        target_heading.text(); 
     
      
  
	});
});	


document.addEventListener('DOMContentLoaded', function () {
  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  function getCookie(name) {
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let c = cookies[i].trim();
      if (c.indexOf(name + "=") == 0) {
        return c.substring(name.length + 1, c.length);
      }
    }
    return "";
  }

  // Check if the popup has been shown today
  const popupShown = getCookie('newsletterPopupShown');

  if (!popupShown) {
    // Show the popup after 5 seconds
    setTimeout(function () {
      document.getElementById('newsletter-popup').style.display = 'block';
      setCookie('newsletterPopupShown', 'true', 1); // Set cookie to expire in 1 day
    }, 5000);
  }

  // Close the popup when the close button is clicked
  document.getElementById('close-popup').addEventListener('click', function () {
    document.getElementById('newsletter-popup').style.display = 'none';
  });

  // Close the popup if the user clicks outside of it
  window.addEventListener('click', function (event) {
    if (event.target == document.getElementById('newsletter-popup')) {
      document.getElementById('newsletter-popup').style.display = 'none';
    }
  });
});



  document.addEventListener("DOMContentLoaded", function () {
    // Check if URL contains ?variant=custom
    if (window.location.search.includes("variant=custom")) {
      // Find the "Customize Product" button
      const customizeBtn = document.querySelector("#customize-btn");

      // Add small delay to ensure button is loaded before click
      if (customizeBtn) {
          customizeBtn.click();
          console.log("Auto-clicked Customize Product button (variant=custom detected)");
      }
    }
  });

  // open chat box on Contact page chat with online click 
    function openChatBot(){

    const host = document.querySelector('inbox-online-store-chat');
    const shadow = host.shadowRoot;
    const button = shadow.querySelector('button');
    const closeButton = shadow.querySelector('button.chat-app--close-button');
    if(host.getAttribute('is-open') === 'true')
    {
      closeButton.click();
    }
    else{

      button.click();
    }
  }

  // open quick quoter on collection banner btn click
 function collectionButtonCstmcick(){
    document.querySelector('#customPackagingTrigger').click();
  }